(() => {
  if (window.__faProductAddonsLoaded) return;
  window.__faProductAddonsLoaded = true;

  const clampQty = (value) => Math.min(20, Math.max(0, Number.parseInt(value, 10) || 0));

  function init(addons) {
    if (!addons || addons.dataset.initialized === 'true') return;
    addons.dataset.initialized = 'true';
    const form = addons.closest('form[action*="/cart/add"]');
    if (!form) return;
    const status = addons.querySelector('[data-fa-addon-status]');

    addons.querySelectorAll('[data-fa-addon]').forEach((card) => {
      const qty = card.querySelector('[data-fa-addon-qty]');
      const setQty = (next) => {
        if (!qty || qty.disabled) return;
        qty.value = String(clampQty(next));
        card.classList.toggle('is-selected', Number(qty.value) > 0);
      };
      card.querySelector('[data-fa-addon-minus]')?.addEventListener('click', () => setQty(Number(qty.value) - 1));
      card.querySelector('[data-fa-addon-plus]')?.addEventListener('click', () => setQty(Number(qty.value) + 1));
      qty?.addEventListener('change', () => setQty(qty.value));
    });

    addons.querySelectorAll('[data-fa-addon-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.faAddonFilter || 'all';
        addons.querySelectorAll('[data-fa-addon-filter]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        addons.querySelectorAll('[data-fa-addon]').forEach((card) => {
          const category = card.dataset.category || '';
          const isKnown = category === 'chocolates' || category === 'teddy-bear';
          const visible = filter === 'all' || category === filter || (filter === 'others' && !isKnown);
          card.hidden = !visible;
        });
      });
    });

    form.addEventListener('submit', async (event) => {
      const selected = Array.from(addons.querySelectorAll('[data-fa-addon]')).map((card) => ({
        id: Number(card.dataset.variantId),
        quantity: clampQty(card.querySelector('[data-fa-addon-qty]')?.value),
        available: card.dataset.available === 'true'
      })).filter((item) => item.id && item.quantity > 0 && item.available);

      if (!selected.length || event.defaultPrevented) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      const variantInput = form.querySelector('.product-variant-id, input[name="id"]');
      const quantityInput = form.querySelector('input[name="quantity"]');
      const mainId = Number(variantInput?.value);
      if (!mainId) return;

      const properties = {};
      new FormData(form).forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && String(value) !== '') properties[match[1]] = String(value);
      });

      const submitter = event.submitter || form.querySelector('button[name="add"]');
      submitter?.setAttribute('aria-busy', 'true');
      if (submitter) submitter.disabled = true;
      status.textContent = 'Adding product and selected add-ons…';
      delete status.dataset.state;

      const requestController = new AbortController();
      const requestTimeout = window.setTimeout(() => requestController.abort(), 12000);
      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          signal: requestController.signal,
          body: JSON.stringify({
            items: [
              { id: mainId, quantity: clampQty(quantityInput?.value || 1) || 1, properties },
              ...selected.map(({ id, quantity }) => ({ id, quantity }))
            ]
          })
        });
        const payload = await response.json().catch(() => null);
        if (!response.ok) throw new Error(payload?.description || payload?.message || `HTTP ${response.status}`);
        status.textContent = 'Added to cart.';
        window.location.assign(window.routes?.cart_url || '/cart');
      } catch (error) {
        console.error('[FlowerAdvisor] Add-on cart bundle failed.', error);
        status.textContent = error?.name === 'AbortError'
          ? 'The request took too long. Please check your connection and try again.'
          : 'Could not add the selected add-ons. Please try again.';
        status.dataset.state = 'error';
        submitter?.removeAttribute('aria-busy');
        if (submitter) submitter.disabled = false;
      } finally {
        window.clearTimeout(requestTimeout);
      }
    }, true);
  }

  function initAll(root = document) { root.querySelectorAll?.('[data-fa-addons]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
